import React, {useState} from 'react';
import AsyncSelect from 'react-select/async';
import SelectSvgSelector from '../InputSelect/SelectSvgSelector';
import {deliveryAPI} from '../../API/api';
import {useFormikContext} from 'formik';
import {useTranslation} from 'react-i18next';
import CustomAsyncSelect from '../Select/CustomAsyncSelect';

const AreasSelector = ({fieldName}: {fieldName: string}) => {
	const {t} = useTranslation();
	const [value, setValue] = useState({
		label: t('Оберіть область'),
		value: '',
	});
	const {setFieldValue} = useFormikContext();
	const handleChange = (newValue: any) => {
		setValue({
			label: newValue.label,
			value: newValue.value,
		});
		setFieldValue(fieldName, newValue.value);
	};
	const loadOptions = async () => {
		try {
			const areas: any = await deliveryAPI.getAreaInNP();
			const options = areas?.data?.data?.map((area: any) => ({
				value: area.Ref,
				label: area.Description,
			}));
			return [...options];
		} catch (error: any) {
			console.error('Error loading options:', error);
			return [];
		}
	};
	return (
		<div>
			<CustomAsyncSelect
				name={fieldName}
				isClearable={false}
				loadOptions={loadOptions}
				cacheOptions
				defaultOptions={true}
				value={value}
				onChange={handleChange}
			/>
		</div>
	);
};

export default AreasSelector;
